"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _text = _interopRequireDefault(require("@ux/text"));
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
var _image = require("@site/pattern-library-core/image");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _density = require("@site/pattern-library-utils/density");
var _tooltipFlyout = _interopRequireDefault(require("@site/pattern-library-core/tooltip-flyout"));
var _configContext = require("../context/config-context");
var _bulletList = _interopRequireDefault(require("./bullet-list"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pc-ch5dzmr"
});
const TitleContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TitleContainer",
  class: "pc-t21ojba"
});
const StyledTooltipFlyout = /*#__PURE__*/(0, _react2.styled)(_tooltipFlyout.default)({
  name: "StyledTooltipFlyout",
  class: "pc-s17mlllh"
});

/**
 * ProductContent Component
 *
 * @param {Object} props props
 * @param {string} props.title Title of the product
 * @param {string} props.description Dscription of the product
 * @param {Object} props.flyout Flyout Tooltip component for the product
 * @param {string} props.sharedTagLabels Label for the product tag
 * @param {string} props.dataCy data-cy attribute value
 * @param {string} props.secondaryTitle secondaryTitle
 * @param {object} props.image Image object
 * @returns {React.ReactElement} ProductContent Component
 * @public
 */
// eslint-disable-next-line complexity
function ProductContent({
  title,
  description,
  list,
  flyout,
  productTagLabels,
  sharedTagLabels,
  dataCy = 'product',
  secondaryTitle,
  image,
  titleSize = 1
}) {
  const {
    asModal
  } = (0, _configContext.useConfig)() || {};
  const flyoutParsedProps = (0, _react.useMemo)(() => {
    if (flyout && typeof window?._swp?.parseTree === 'function') {
      // parseTree mutates the object in-place and doesn't return anything
      // Deep clone before parseTree to avoid mutating the original props
      const flyoutCopy = JSON.parse(JSON.stringify(flyout));
      window._swp.parseTree(flyoutCopy);
      return flyoutCopy;
    }
    return flyout;
  }, [flyout]);
  if (!title) return null;
  return /*#__PURE__*/_react.default.createElement(Container, {
    "data-cy": `${dataCy}-product`,
    className: "product-content"
  }, sharedTagLabels && sharedTagLabels.map(({
    text: tagText,
    design
  }, index) => /*#__PURE__*/_react.default.createElement(_tag.default, {
    key: index,
    dataCy: `${dataCy}-tag-${index}`,
    className: "tag",
    text: tagText,
    design: design || 'neutral',
    size: "sm"
  })), /*#__PURE__*/_react.default.createElement(TitleContainer, null, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    "data-cy": `${dataCy}-title`,
    as: "title",
    text: title,
    size: titleSize
  }), flyoutParsedProps && Object.keys(flyoutParsedProps).length > 0 && /*#__PURE__*/_react.default.createElement(StyledTooltipFlyout, (0, _extends2.default)({}, flyoutParsedProps, {
    className: asModal ? 'in-modal' : ''
  })), productTagLabels && productTagLabels.map(({
    text: tagText,
    design
  }, index) => /*#__PURE__*/_react.default.createElement(_tag.default, {
    key: index,
    dataCy: `${dataCy}-tag-${index}`,
    text: tagText,
    design: design || 'highlight',
    size: "sm"
  }))), description && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    "data-cy": `${dataCy}-description`,
    as: "paragraph",
    size: -1,
    dangerouslySetInnerHTML: {
      __html: _dompurify.default.sanitize(description)
    }
  }), list && list.length > 0 && /*#__PURE__*/_react.default.createElement(_bulletList.default, {
    list: list,
    dataCy: dataCy
  }), secondaryTitle && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    "data-cy": `${dataCy}-secondary-title`,
    as: "title",
    text: secondaryTitle,
    size: -1
  }), image && /*#__PURE__*/_react.default.createElement(_image.LazyImage, {
    dataCy: 'attachment-image',
    url: image?.url,
    altText: image?.altText,
    height: image?.height,
    width: image?.width
  }));
}
var _default = exports.default = ProductContent;
ProductContent.propTypes = {
  title: _propTypes.default.string,
  description: _propTypes.default.string,
  list: _propTypes.default.array,
  flyout: _propTypes.default.object,
  sharedTagLabels: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string,
    design: _propTypes.default.string
  })),
  productTagLabels: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string,
    design: _propTypes.default.string
  })),
  dataCy: _propTypes.default.string,
  secondaryTitle: _propTypes.default.string,
  image: _propTypes.default.shape({
    url: _propTypes.default.string,
    altText: _propTypes.default.string,
    height: _propTypes.default.string,
    width: _propTypes.default.string
  }),
  titleSize: _propTypes.default.oneOf([0, 1, 2, 3, 4, 5, 6])
};